import throttle from 'lodash.throttle';
import { useEffect, useState } from 'react';

let previousYPosition = window.pageYOffset;
let previousScrollDirection = 'DOWN';
const MIN_DELTA = 2;

const getPosition = () => {
  const y = window.pageYOffset;
  const delta = y - previousYPosition;
  const scrollDirection =
    delta > MIN_DELTA
      ? 'DOWN'
      : delta < -MIN_DELTA
        ? 'UP'
        : previousScrollDirection;
  return {
    y,
    scrollDirection,
    previousScrollDirection,
  };
};

const handleScroll = (setPosition) =>
  throttle(() => {
    const newPosition = getPosition();
    previousYPosition = newPosition.y;
    previousScrollDirection = newPosition.scrollDirection;
    setPosition(newPosition);
  }, 300);

const useScrollDirection = () => {
  const [position, setPosition] = useState(getPosition());

  useEffect(() => {
    const handleScrollFunc = handleScroll(setPosition);
    window.addEventListener('scroll', handleScrollFunc, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScrollFunc);
      handleScrollFunc.cancel();
    };
  }, []);

  return position;
};

export default useScrollDirection;
